import { Dialog, DialogContent, DialogContentText, Grid, Link, List, ListItem, makeStyles } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { createStyles } from '@material-ui/core/styles';
import { useState } from 'react';

const useStyles = makeStyles(() =>
  createStyles({
    appBar: {
      top: 'auto',
      bottom: 0,
      height: 60,
      color: 'black'
    },
    toolBar: {
      backgroundColor: '#f5f5f5'
    },
    listItem: {
      padding: 1
    },
    right: {
      marginLeft: 'auto',
      paddingTop: 8
    }
  })
);

const Footer = (): JSX.Element => {
  const classes = useStyles();
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleDialogOpen = () => {
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  return (
    <div>
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar className={classes.toolBar}>
          <Grid container alignItems="flex-start">
            <Grid>
              <List>
                <ListItem className={classes.listItem}>
                  <Link target="_blank" href="https://comptroller.texas.gov/about/policies/privacy.php">
                    Privacy & Security Policy
                  </Link>
                </ListItem>
                <ListItem className={classes.listItem}>
                  <Link target="_blank" href="https://comptroller.texas.gov/about/policies/">
                    Other Policies
                  </Link>
                </ListItem>
              </List>
            </Grid>
            <Grid className={classes.right}>
              <Link component="button" onClick={handleDialogOpen} variant="subtitle1">
                Contact Us
              </Link>
              <Dialog open={dialogOpen} onClose={handleDialogClose}>
                <DialogContent>
                  <DialogContentText>
                    <strong>Email:</strong>{' '}
                    <a href="mailto:match.the.promise@cpa.texas.gov?subject=Public Inquiry from MTPF Site">
                      match.the.promise@cpa.texas.gov
                    </a>
                  </DialogContentText>
                  <DialogContentText>
                    <strong>Phone:</strong> 800-531-5441, ext. 3-7570
                  </DialogContentText>
                </DialogContent>
              </Dialog>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      <Toolbar />
    </div>
  );
};

export default Footer;
